import { Injectable } from '@angular/core';
import { LoadingController, Loading } from 'ionic-angular';

@Injectable()
export class LoaddingService {
    constructor(
        private loadingCtrl: LoadingController) {
    }

    //加载显示
    public showLoding(msg: string = "加载中...", spinner: string = "ios", duration: number = 3000) {
        let loading = this.loadingCtrl.create({
            content: msg,
            spinner: spinner
        });

        loading.present();

        return loading;
    }

    //清除加载
    public closeLoading(loadingInstance: Loading) {
        if (loadingInstance) {
            loadingInstance.dismiss();
        } else {
            loadingInstance.dismissAll();
        }
    }
}


// WEBPACK FOOTER //
// ./src/providers/loadding.service.ts